import { CreateElement, Point, Scale, SetStyles, Size, TranslatePointScreen1To1 } from "../../.././MyHelpers";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { CanvasSprite } from "../../Sprite/CanvasSprite";
import { BigSymbolFreegamesBonus } from "./BigSymbolFreegames";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import { Elastic, TweenMax } from "gsap";
import * as PIXI from 'pixi.js';
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";
import { service } from "../../../services";
import { MyCanvas, MyCanvasContext } from "../../MyCanvas";
import { BigSymbolFreegamesState } from "../BigSymbolFreegames/BigSymbolFreegamesState";
import { BigSymbolFreegamesMessages } from "./BigSymbolFreegamesMessages";
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";
export class BigSymbolFreeGameBonus_1Screen extends BigSymbolFreegamesBonus {
    public override CreateTransitionPixi(app? : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}

    //CHANGE POSITION PLUS ONE TARGET
    protected override plusOneTarget: Point = TranslatePointScreen1To1(new Point(Scale.X(280), Scale.Y(70)));

    //CREATE DIV TRASITION ONLY IM8
    //protected transitionView: HTMLElement = null;
    protected PathGame: string = null;

    //Create Stats FG 
    protected StatsContainer: HTMLElement = null;
    protected freegameStats: HTMLElement = null;
    protected FreegamesNumValue: HTMLElement = null;
    protected FreegamesNumTitle: HTMLElement = null;
    protected freegameStats2: HTMLElement = null;
    protected FreegamesPlayedValue: HTMLElement = null;
    protected TotalPlayed: HTMLElement = null;
    protected CanvasInfo: MyCanvas[] = [];
    protected CtxCanvasInfo: MyCanvasContext[] = [];
    protected StatsInfoFontHeight: number = Scale.fh(65);
    protected spinsPlayedBackgroundSprite: CanvasSprite = null;
    protected spinsRemainingBackgroundSprite: CanvasSprite = null;
    //WIN CONTAINER
    protected WinContainer: HTMLElement = null;
    protected FrameContainer: HTMLElement = null;
    protected FrameSprite: CanvasSprite = null;
    protected BonusSprite: CanvasSprite = null;

    public constructor(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration) {
        super(gameName, params, config);
        this.PathGame = Settings.ResourcesFolder + "multigame/slot/" + gameName + "/resources/"

    }

    protected override async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        await super.BasePrepare(resourceManager);
        // resourceManager.Add(new ImageResource(this.PathGame + "BackgroundTransition_1Screen.png", this.resid.ScopedResourceName(["BackgroundTransition", "image"])));
        await this.LoadSrites(resourceManager);
    }

  

    protected override async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        await super.BaseLoaded(resourceManager);

        this.StatsContainer = CreateElement("div", {
            classes: [this.resid.Scope() + "-stats-container"],
            parentToAppend: this.view,
            style: {
                display: "flex",
                position: "absolute",
                width: Scale.Wpx(892),
                height: Scale.Hpx(182),
                left: Scale.Hpx(65),


            }
        });

        await this.FreeGameStatsLeft(resourceManager);
        await this.FreeGameStatsRight(resourceManager);
        await this.WinFrameLoaded(resourceManager);
        await this.CanvaswinCount();
        this.TotalPlayed.appendChild(this.translator.Anchor(() => this.translator.t.playedBigFG));
        //this.wins.appendChild(this.translator.Anchor(() => this.translator.t.win));
        //this.played.appendChild(this.translator.Anchor(() => this.translator.t.played));
        this.FreegamesNumTitle.appendChild(this.translator.Anchor(() => this.translator.t.leftbigfg));
    }


    protected override ExtraSymbolsAbove(): number {
        //Quit Exta Symbol
        let reel: number = 0;
        return reel
    }

    //LOAD TITLE FOR TRANSITION 
    public LoadTitleTransition(resourceManager: ResourceManager) {


        //this.TitleSpriteTransition = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("freegame3d")).sprite.Copy());
        this.TitleSpriteTransition = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("freegame3d")).sprite, canvasSize: new Size(Scale.W(1920), Scale.H(1080))});

        this.TitleSpriteTransition.View().style.position = "absolute";
        this.TitleSpriteTransition.View().style.visibility = "hidden";
        this.TitleSpriteTransition.View().style.zIndex = ZIndex.BonusTransitionTitle.toString();
        this.TitleSpriteTransition.View().style.top = Scale.Xpx(0);
        this.TitleSpriteTransition.View().classList.add("Titlefreegame3d");
        this.TitleSpriteTransition.AddOnStartCallback(() => { this.audio.Play(this.resid.ScopedResourceName("transitionLight")); })
        this.TitleSpriteTransition.AddOnStartCallback(() => { this.audio.Play(this.resid.ScopedResourceName("freegame")); })
        this.view.appendChild(this.TitleSpriteTransition.View());




        // this.transitionView = document.createElement("div");
        // this.transitionView.classList.add("TransitionSpinAndHold");
        // this.transitionView.style.height = Scale.Hpx(1080);
        // this.transitionView.style.width = Scale.Wpx(1920);
        // this.transitionView.style.top = "0px";
        // this.transitionView.style.display = "none";
        // this.transitionView.style.position = "absolute";
        // this.transitionView.style.zIndex = ZIndex.BonusTransition.toString();
        // this.transitionView.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["BackgroundTransition", "image"])).CssBackground(),
        //     this.transitionView.style.backgroundSize = "contain";
        // this.view.appendChild(this.transitionView);
    }

    protected LoadSrites(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new SpriteResource(this.params.gamePath + "resources/BigSymbolFreegames/ValueContainer", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName + "ValueContainer"), true, this.logGroup.Add(this.gameName), true));
        resourceManager.Add(new SpriteResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
        
        resourceManager.AddGlobal(new SpriteResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/BonusWin", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("BonusTitleBigSymbolFreegames"), true, this.logGroup.Add("freegame"), true));
    }

    // public ShowVideoTransition(): void {
    //     if (this.started == false) {
    //         this.started = true;
    //         // Log.Debug(this.logGroup, "Start transition");
    //         this.OnTransitionStarted();
    //         TweenMax.set(this.transitionView, { autoAlpha: 1, display: "" });

    //         //this.TitleSpriteTransition.View().style.visibility = "visible";
    //         //this.transitionView.style.visibility = "visible";
    //         //this.transitionView.style.display = "";

    //         // fadeout
    //         setTimeout(() =>
    //             TweenMax.to(this.transitionView, 2, {
    //                 autoAlpha: 0, onComplete: () => {
    //                     //video.StopAndReset(this.resid);
    //                     //video.Hide();
    //                     //this.transitionView.style.display = "none";
    //                    // this.transitionView.style.display = "none";

    //                     this.OnTransitionEnded();
    //                 }
    //             }
    //             ), 2000);


    //         setTimeout(() =>
    //             TweenMax.fromTo(this.TitleSpriteTransition.View(), 0.5, {
    //                 autoAlpha: 0, display: "none"
    //             }, { autoAlpha: 1, display: "block", onComplete: () => { this.TitleSpriteTransition.Start(false); } }
    //             ), 500);



    //         setTimeout(() =>
    //             TweenMax.to(this.TitleSpriteTransition.View(), 1, { autoAlpha: 0, display: "none" }
    //             ), 2000);



    //     }

    // }

    protected FreeGameStatsLeft(resourceManager: IReadOnlyResourceManager) {
        this.freegameStats = CreateElement("div", {
            classes: [this.resid.Scope() + "-freegame-stats"],
            parentToAppend: this.StatsContainer,
            style: {
                display: "flex",
                position: "absolute",
                //width: Scale.Wpx(422),
                height: Scale.Hpx(183),
                top: Scale.Ypx(0),
                left: Scale.Xpx(111),
                zIndex: ZIndex.HoldAndStopBonusStats.toString(),
                bottom: Scale.Ypx(0),
                justifyContent: "center",
                flexDirection: "column",
                boxSizing: "border-box",
                //backgroundColor:"black",

            }
        });

        this.FreegamesNumValue = CreateElement("div", {
            classes: [this.resid.Scope() + "-freegames-left-value", "freegames-num-value"],
            parentToAppend: this.freegameStats,
            style: {
                display: "flex",
                justifyContent: "center",
                // width:Scale.Xpx(460),

            }
        });


        this.FreegamesNumTitle = CreateElement("div", {
            classes: [this.resid.Scope() + "-freegames-num-title"],
            parentToAppend: this.freegameStats,
            style: {
                position: "relative",
                //top: Scale.Xpx(74),

                fontSize: Scale.fhpx(30),
                fontFamily: this.resid.ScopedResourceName("font"),
                color: "yellow",
                textAlign: "center",
                alignItems: "center",
                alignContent: "center",
                alignSelf: "center",

                textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`
            }
        });

        this.spinsRemainingBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName + "ValueContainer")).sprite, canvasSize: new Size(Scale.W(150), Scale.H(150))});
        this.spinsRemainingBackgroundSprite.Start(true);
        this.spinsRemainingBackgroundSprite.View().style.position = "absolute";
        //this.spinsRemainingBackgroundSprite.View().style.left=Scale.Xpx(0);
        this.spinsRemainingBackgroundSprite.View().style.top = Scale.Ypx(0);
        this.spinsRemainingBackgroundSprite.Scale(1.3);
        this.FreegamesNumValue.appendChild(this.spinsRemainingBackgroundSprite.View());
    }

    protected FreeGameStatsRight(resourceManager: IReadOnlyResourceManager) {
        this.freegameStats2 = CreateElement("div", {
            classes: [this.resid.Scope() + "-freegameStats2"],
            style: {
                position: "absolute",
                left: Scale.Xpx(531),
                //width: Scale.Wpx(422),
                height: Scale.Hpx(183),
                top: Scale.Ypx(0),
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                flexDirection: "column",
                boxSizing: "border-box",
                //backgroundColor: "black",
            }
        });

        this.FreegamesPlayedValue = CreateElement("div", {
            classes: [this.resid.Scope() + "-freegames-right-value", "freegames-played-num-value"],
            parentToAppend: this.freegameStats2,
            style: {
                display: "flex",
                //width:Scale.Xpx(460),
                justifyContent: "center",
            }
        });

        this.TotalPlayed = CreateElement("div", {
            classes: [this.resid.Scope() + "-total-played"],
            parentToAppend: this.freegameStats2,
            style: {
                position: "relative",
                //top:Scale.Xpx(124),

                fontSize: Scale.fhpx(30),
                fontFamily: this.resid.ScopedResourceName("font"),
                color: "yellow",
                textAlign: "center",
                alignItems: "center",
                alignContent: "center",
                alignSelf: "center",

                textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`

            }
        });
        this.freegameStats2.appendChild(this.TotalPlayed);
        this.StatsContainer.appendChild(this.freegameStats2);


        this.spinsPlayedBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName + "ValueContainer")).sprite, canvasSize: new Size(Scale.W(150), Scale.H(150))});
        this.spinsPlayedBackgroundSprite.Scale(1.3);
        this.spinsPlayedBackgroundSprite.Start(true);
        this.spinsPlayedBackgroundSprite.View().style.position = "absolute";
        this.spinsPlayedBackgroundSprite.Start(true);
        //this.spinsPlayedBackgroundSprite.View().style.left=Scale.Xpx(0);
        this.spinsPlayedBackgroundSprite.View().style.top = Scale.Ypx(0);
        this.FreegamesPlayedValue.appendChild(this.spinsPlayedBackgroundSprite.View());
    }

    public SetTextCanvasInfoStats(text: string, ctx: MyCanvasContext, CanvasElement: MyCanvas) {
        ctx.clearRect(0, 0, CanvasElement.size.Width, CanvasElement.size.Height);
        ctx.strokeStyle = "black";
        ctx.lineWidth = Scale.fh(15);
        ctx.strokeText(text, (CanvasElement.size.Width / 2), (CanvasElement.size.Height / 4));

        ctx.strokeStyle = "white";
        ctx.lineWidth = Scale.fh(10) / 4;
        ctx.strokeText(text, (CanvasElement.size.Width / 2), (CanvasElement.size.Height / 4));

        ctx.fillText(text, (CanvasElement.size.Width / 2), (CanvasElement.size.Height / 4));
    }

    protected CanvaswinCount() {
        for (let a = 0; a < 3; a++) {


            
            document.createElement("canvas");
            if (a == 0 || a == 1) {
                this.CanvasInfo[a] = new MyCanvas(new Size(Scale.W(150), Scale.H(150)), {
                    style: {
                        left: Scale.Xpx(2),
                        top: Scale.Ypx(2),
                        position: "relative",
                        zIndex: "" + ZIndex.BonusWin,
                    }
                });
                
                // this.CanvasInfo[a].width = Scale.W(150);
                // this.CanvasInfo[a].height = Scale.H(150);
                // this.CanvasInfo[a].style.left = Scale.Xpx(2);
                // this.CanvasInfo[a].style.top = Scale.Ypx(2);
            }
            else {
                this.CanvasInfo[a] = new MyCanvas(new Size(Scale.W(475), Scale.H(140)), {
                    style: {
                        left: Scale.Xpx(2),
                        top: Scale.Ypx(2),
                        position: "relative",
                        zIndex: "" + ZIndex.BonusWin,
                    }
                });

                // this.CanvasInfo[a].width = Scale.W(475);
                // this.CanvasInfo[a].height = Scale.H(140);
                this.StatsInfoFontHeight = Scale.fh(75);
                // this.CanvasInfo[a].style.top = Scale.Ypx(26);
                // this.CanvasInfo[a].style.left = Scale.Xpx(21);
            }
            //this.CanvasInfo[a].style.position = "relative";
            //this.CanvasInfo[a].style.display = "flex";
            //this.CanvasInfo[a].style.alignItems = "center";
            //this.CanvasInfo[a].style.justifyContent = "center";
            //this.CanvasInfo[a].style.zIndex="3";
            //this.CanvasInfo[a].style.zIndex = "" + ZIndex.BonusWin;

            //add gradient
            this.CtxCanvasInfo[a] = this.CanvasInfo[a].context;

            //this.ctx.font = "120px Verdana" /*+ this.font*/;
            this.CtxCanvasInfo[a].font = "bold " + this.StatsInfoFontHeight + "px " + this.resid.ScopedResourceName("bigwincount");

            let color: string = "orangered";
            let color2: string = "yellow";

            let gradient = this.CtxCanvasInfo[a].createLinearGradient(
                this.CanvasInfo[a].size.Width / 2,
                this.CanvasInfo[a].size.Height / 2 - this.StatsInfoFontHeight / 2,
                this.CanvasInfo[a].size.Width / 2,
                this.CanvasInfo[a].size.Height / 2 + this.StatsInfoFontHeight / 2
            );

            this.CtxCanvasInfo[a].lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
            this.CtxCanvasInfo[a].miterLimit = 2;

            gradient.addColorStop(0, color);

            gradient.addColorStop(0.70, color2);


            gradient.addColorStop(1, color);


            this.CtxCanvasInfo[a].fillStyle = gradient;

            this.CtxCanvasInfo[a].textBaseline = "top";
            this.CtxCanvasInfo[a].textAlign = "center";


            if (a == 0) {
                this.FreegamesNumValue.appendChild(this.CanvasInfo[a].View());
            }

            if (a == 1) {
                this.FreegamesPlayedValue.appendChild(this.CanvasInfo[a].View());
            }
            if (a == 2) {
                this.FrameContainer.appendChild(this.CanvasInfo[a].View());
                this.SetTextCanvasInfoStats("?", this.CtxCanvasInfo[2], this.CanvasInfo[2]);

            }
        }

    }

    protected WinFrameLoaded(resourceManager: IReadOnlyResourceManager) {

        this.WinContainer = document.createElement("div");
        this.WinContainer.style.width = Scale.Wpx(961);
        this.WinContainer.style.height = Scale.Hpx(182);
        this.WinContainer.style.left = Scale.Hpx(0);
        this.WinContainer.style.position = "absolute";
        this.WinContainer.style.justifyContent = "center";
        this.WinContainer.style.alignContent = "center";
        //this.WinContainer.style.overflow = "hidden";
        this.WinContainer.style.zIndex = ZIndex.WinContainerBigFG.toString();
        // this.WinContainer.style.backgroundColor="rgba(0,0,0,0.5)";
        this.WinContainer.style.display = "none";


        this.BonusSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("BonusTitleBigSymbolFreegames")).sprite, canvasSize: new Size(Scale.W(450), Scale.H(170))});
        this.BonusSprite.View().style.position = "absolute";
        this.BonusSprite.View().style.top = Scale.Ypx(0);
        this.BonusSprite.ScaleNonUniform(1.18, 1.4);

        //this.BonusSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
        this.WinContainer.appendChild(this.BonusSprite.View());

        this.FrameContainer = document.createElement("div");
        this.FrameContainer.classList.add(this.resid.Scope());
        this.FrameContainer.classList.add("FrameContainer");
        SetStyles(this.FrameContainer,
            {
                position: "absolute",
                //top: Scale.Ypx(257),
                left: Scale.Xpx(434),
                width: Scale.Wpx(520),
                height: Scale.Hpx(192),
                display: "block",
                //flexDirection:"column",


            });

        let BackgroundContainer = CreateElement("div", {
            parentToAppend: this.FrameContainer,
            style: {
                backgroundColor: "rgba(0,0,0,0.7)",
                width: Scale.Wpx(484),
                height: Scale.Hpx(146),
                position: "absolute",
                //top: Scale.Ypx(133),
                left: Scale.Xpx(21),
                top: Scale.Ypx(20),

            }
        });



        let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
        this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(520), Scale.H(192))});
        this.FrameSprite.View().style.position = "absolute";
        //this.FrameSprite.View().style.top = Scale.Ypx(65);
        this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
        this.FrameContainer.appendChild(this.FrameSprite.View());
        this.FrameSprite.ScaleNonUniform(1, 1.5);
        this.WinContainer.appendChild(this.FrameContainer);
        this.view.appendChild(this.WinContainer);

    }

    public override Start(): void {

        this.StatsContainer.style.display = "block";
        this.ReDrawCanvasButton();

        // Log.Debug(this.logGroup, "Bonus started");

        //this.basegameWinCents = basegameWinCents;

        this.lastSpinResult = null;
        this.session.Reset();
        this.session.RunsPlayed = 0;
        
        let startBonusIndex =  this.startConfig.findIndex(b=>b.Action == "BigSymbolFreegamesStartAction");
        this.session.RunsStarted = this.startConfig[startBonusIndex].SpinsStarted;
        this.session.RunsRemaining = this.startConfig[startBonusIndex].SpinsStarted;
        this.spinIndexData = startBonusIndex;		
        
        // this.session.ScattersDisplayed = this.startConfig.StartingState.FeatureResults.ScatterRandomAward &&
        // 	this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersTotal || 0;

        this.stateMachine.ChangeState(BigSymbolFreegamesState.IntroMessage);
        //this.stateMachine.ChangeState(BigSymbolFreegamesState.WaitFirstSpin);

        // Log.Debug(this.logGroup, "Bonus started");

        this.Show();

        this.PanelRequired(true);

        this.audio.Stop(this.resid.ScopedResourceName("background"));
        this.audio.PlayLoop(this.resid.ScopedResourceName("background"));


        this.SetTextCanvasInfoStats(this.session.RunsStarted.toString(), this.CtxCanvasInfo[0], this.CanvasInfo[0]);
        this.SetTextCanvasInfoStats("0", this.CtxCanvasInfo[1], this.CanvasInfo[1]);

        // TODO use different message for start instead of SPIN
        this.screenProtocol?.Send(new BigSymbolFreegamesMessages.SpinMessage(this.session), this.screenProtocolScope);

    }

    protected override OnSpinBegin(): void {
        super.OnSpinBegin();
        this.SetTextCanvasInfoStats(this.session.RunsRemaining.toString(), this.CtxCanvasInfo[0], this.CanvasInfo[0]);
        this.SetTextCanvasInfoStats(this.session.RunsPlayed.toString(), this.CtxCanvasInfo[1], this.CanvasInfo[1]);

    }

    public override Update(): void {
        super.Update();
        this.spinsRemainingBackgroundSprite.Update();
        this.spinsPlayedBackgroundSprite.Update();
        this.FrameSprite.Update();
        this.BonusSprite.Update();

    }

    protected override OnFinalMessageBegin(): void {
        super.OnFinalMessageBegin();
        //this.WinContainer.style.display = "block";        
        this.StatsContainer.style.display = "none";
        this.FrameSprite.Start(true);
        this.BonusSprite.Start(true);
        setTimeout(() =>
            (this.SetTextCanvasInfoStats(service.moneyFormatter.FormatCurrency(this.session.TotalWin), this.CtxCanvasInfo[2], this.CanvasInfo[2])
            ), 500);

        TweenMax.fromTo(this.WinContainer, 1, {
            x: Scale.Xpx(-892), display: "block"

        }, {
            x: Scale.Xpx(0), ease: Elastic.easeOut.config(1, 1)
        });
    }
    protected override OnFinalMessageEnd(): void {
        super.OnFinalMessageEnd();
        this.WinContainer.style.display = "none";
        this.SetTextCanvasInfoStats("?", this.CtxCanvasInfo[2], this.CanvasInfo[2])
        this.BonusSprite.Stop();
        this.FrameSprite.Stop();
    }
    //Create For Update The Session For RunsRemaining 1 Screen Game
    protected override ApplySession(RunsRemaining: number): void {
        setTimeout(() =>
            (this.SetTextCanvasInfoStats(RunsRemaining.toString(), this.CtxCanvasInfo[0], this.CanvasInfo[0])
            ), 1550);
    }
}
